import { useAppTranslation } from '@hooks';
import { Col, Row, Space } from 'antd';
import { css } from '@emotion/react';
import { IText } from '@types';
import { PropsWithChildren } from 'react';
import { Content, Title } from 'common-components';

export type HeaderManagerPropsType = {
  managersSelectedCount: number
};

const HeaderManagers = ({
  managersSelectedCount,
  children,
}: PropsWithChildren<HeaderManagerPropsType>) => {
  const { translate } = useAppTranslation();

  const texts: IText[] = [
    {
      type: 'tablePageTitle',
      content:
        managersSelectedCount > 0
          ? `${managersSelectedCount} ${
            managersSelectedCount === 1
              ? translate('managers.selectedManager')
              : translate('managers.selectedManagers')
          }`
          : translate('managers.managers'),
    },
    {
      type: 'tablePageSubtitle',
      content: translate('managers.manageTeamInfo'),
    },
  ];

  return (
    <Content>
      <Row
        justify={'space-between'}
        align={'top'}
        wrap={false}
        css={css`
          margin: 24px 0;
          gap: 16px;
        `}
      >
        <Col
          css={css`
            flex: 1;
            min-width: 0;
          `}
        >
          {texts.map((text, index) => {
            return (
              <Title key={`title-${text.content}-${index}`} preset={text.type}>
                {text.content}
              </Title>
            );
          })}
        </Col>
        <Row>
          <Space>{children}</Space>
        </Row>
      </Row>
    </Content>
  );
};

export default HeaderManagers;
